module.exports = require("@wildboar/x500/src/lib/modules/OperationalBindingManagement/ModifyOperationalBindingResult.ta");